import { sendSegmentEvent } from '../lib/segment';
import partnersData, { PartnerCard } from './partners.data';

const shuffleArray = (array) => {
  const returnArray = [...array];
  for (let i = returnArray.length - 1; i > 0; i -= 1) {
    const j = Math.floor(Math.random() * (i + 1));
    const temp = returnArray[i];
    returnArray[i] = returnArray[j];
    returnArray[j] = temp;
  }
  return returnArray;
};

function sendPartnerSegmentEvent(eventName: string, partnerKey: string) {
  const tile: PartnerCard = partnersData.ALL_CARDS()[partnerKey];
  if (tile) {
    sendSegmentEvent(eventName, {
      partnerCardName: partnerKey,
      partnerName: tile.companyName,
      ctaUrl: tile.detailsUrl,
    });
  }
}

function partnerClicked(partnerKey: string): void {
  sendPartnerSegmentEvent('Partner Clicked', partnerKey);
}

function matchesZipCode(candidateKey: string, zipCode?: string) {
  const tile: PartnerCard = partnersData.ALL_CARDS()[candidateKey];
  if (tile.displayZipCodes && tile.displayZipCodes.length > 0 && zipCode) {
    if (!tile.displayZipCodes.includes(zipCode)) {
      return false;
    }
  }
  return true;
}

function getPartners(count: number = 2, zipCode?: string): string[] {
  let activePartners = [...partnersData.ALL_PARENT_PARTNER_KEYS];
  const partnersToDisplay = [] as Array<string>;
  activePartners = shuffleArray(activePartners);
  // eslint-disable-next-line no-restricted-syntax
  for (const candidateKey of activePartners) {
    const zipCodeMatch = matchesZipCode(candidateKey, zipCode);
    if (zipCodeMatch) {
      partnersToDisplay.push(candidateKey);
    }
    if (partnersToDisplay.length === count) break;
  }
  return partnersToDisplay;
}

function getPartnersByCategory(zipCode?: string): Object {
  let activePartnerKeys = [...partnersData.ALL_PARENT_PARTNER_KEYS];
  activePartnerKeys = shuffleArray(activePartnerKeys);

  const activePartners = { ...partnersData.ALL_PARENT_PARTNER_CARDS() };
  const categoryKeys = Object.keys(partnersData.PartnerGroups);
  const partnersToDisplay = {};
  // eslint-disable-next-line no-restricted-syntax
  for (const categoryGroup of categoryKeys) {
    partnersToDisplay[categoryGroup] = [];
  }
  // eslint-disable-next-line no-restricted-syntax
  for (const partnerKey of activePartnerKeys) {
    const partner = activePartners[partnerKey];
    const group = partnersData.partnerCategoryGroup[partner.category];
    const zipCodeMatch = matchesZipCode(partnerKey, zipCode);
    if (zipCodeMatch) {
      partnersToDisplay[group].push(partnerKey);
    }
  }
  return partnersToDisplay;
}

export default {
  getPartners,
  partnerClicked,
  sendPartnerSegmentEvent,
  getPartnersByCategory,
};
